import { getGates } from 'conversations-thread-data/auth/public/selectors';
import { useSelector } from 'react-redux';
export function useIsPopOutUngated() {
  const gates = useSelector(getGates);
  return gates.includes('Communication:Composer:PopOutComposer');
}